export const getConfig = state => (state && state.config) || {};

export const getNavigationConfig = state => getConfig(state).navigation || {};
export const getOrdersConfig = state => getConfig(state).orders || {};
export const getUserConfig = state => getConfig(state).user || {};
export const getOrdersStatuses = state => getOrdersConfig(state).statuses || '';
export const getStoreAdditionalParameter = state =>
    getOrdersConfig(state).sendAdditionalParams || '';
export const getAdditionalParameterDeliveryMode = state =>
    getOrdersConfig(state).additionalParameterDeliveryMode || [];
export const getDownloadEnable = state => getOrdersConfig(state).downloadEnable || false;

export const getCartNotifier = state => getConfig(state).cartNotifier || {};
export const getWishlist = state => getConfig(state).wishlist || {};
export const getNotifyMeList = state => getConfig(state).notifyme || {};
export const getAddressSuggestionConfig = state => getConfig(state).AddressSuggestion || {};
export const getAddressRelationsConfig = state => getConfig(state).addressRelations || {};
export const shouldRequestCityListOnInit = state =>
    getAddressRelationsConfig(state).requestCitiesOnInitialize || false;
export const isChangingCityAffectsDistricts = state =>
    getAddressRelationsConfig(state).changingCityAffectsDistricts || false;
export const getAddressVerificationDialogConfig = state =>
    getConfig(state).addressVerificationDialog || {};
export const getFiltersConfig = state => getConfig(state).plpFiltersConfig.plpFilters || {};
export const getPayment = state => getConfig(state).payment || {};
export const getRealTimeStock = state => getConfig(state).realTimeStock || {};
export const getChangeEmail = state => getConfig(state).changeEmail || {};
export const getDeliveryModes = state => getConfig(state).deliveryModes || {};
export const getForms = state => getConfig(state).forms || {};
export const getRegistrationFormConfig = state => getConfig(state).registration || {};
export const getAgeVerification = state => getConfig(state).ageVerification || {};
export const getValidationOnInputConfig = state => getConfig(state).validationOnInput || {};
export const getCartConfig = state => getConfig(state).cart || {};
export const getPersonalInformationFormConfig = state =>
    getConfig(state).personalInformationFormConfig || {};
export const getDynaFormConfig = state => getConfig(state).dynaFormConfig || {};
export const getDigitalCardFormConfig = state => getConfig(state).loyaltyCardFormConfig || {};
export const getMobileFiltersConfig = state => getFiltersConfig(state).mobile || {};
export const getTabletFiltersConfig = state => getFiltersConfig(state).tablet || {};
export const getDesktopFiltersConfig = state => getFiltersConfig(state).desktop || {};
export const getBeforeApplyFiltersConfig = state =>
    getConfig(state).plpFiltersConfig.beforeApplyFilters || '';
export const getShowStoredPriceInfo = state =>
    getConfig(state).plpFiltersConfig.showStoredPriceInfo || false;
export const getProductListWrapperId = state => getFiltersConfig(state).productListWrapperId || '';
export const getDesktopFiltersGroupId = state =>
    getFiltersConfig(state).desktopFiltersGroupId || '';
export const getMobileFiltersGroupId = state => getFiltersConfig(state).mobileFiltersGroupId || '';
export const getAlphabetList = state => getFiltersConfig(state).alphabetTabs || {};
export const getPageUpdateSelectorsList = state =>
    getFiltersConfig(state).pageUpdateSelectorsList || [];
export const getFilterLoadingModifier = state => getFiltersConfig(state).filterLoadingModifier;
export const skipCartForcedMessages = state => getCartNotifier(state).skipForcedMessages;
export const useDialogCartNotifier = state => getCartNotifier(state).updateNotifier === 'dialog';

export const getAddToWishlistStrategies = state => getWishlist(state).add;
export const addProductAfterUserLogin = state => !!getWishlist(state).addProductAfterUserLogin;
export const showPopupAfterAddingProduct = state => !!getWishlist(state).showPopupAfterAdding;
export const getAddToNotifyMeListStrategies = state => getNotifyMeList(state).add;
export const shouldRedirectToPDPAfterLogin = state => getWishlist(state).redirectToPDPAfterLogin;
export const sendAnalyticsFullProductData = state =>
    !!getWishlist(state).sendAnalyticsFullProductData;

export const notPopulatePersonalDataForGuest = state =>
    getPersonalInformationFormConfig(state).notPopulatePersonalDataForGuest;
export const notPopulatePersonalDataForCustomer = state =>
    getPersonalInformationFormConfig(state).notPopulatePersonalDataForCustomer;
export const requestOnPaymentSelection = state => getPayment(state).requestOnPaymentSelection;
export const newOrderAPI = state => getPayment(state).newOrderAPI;
export const deviceTypeFlag = state => getPayment(state).deviceTypeFlag;
export const useRtsLastStore = state => getRealTimeStock(state).useLastStore;
export const makeChangeDeliveryAddress = state => getCartConfig(state).makeChangeDeliveryAddress;
export const setDeliveryModeAfterSetCartDataAction = state =>
    getCartConfig(state).setDeliveryModeAfterSetCartDataAction;
export const blockDeliveryWithoutAddress = state =>
    getCartConfig(state).blockDeliveryWithoutAddress;
export const showMiniCartOnUnsuccessfulStatus = state =>
    getCartConfig(state).showMiniCartOnUnsuccessfulStatus || false;
export const failRtsOnEmptyStores = state => getRealTimeStock(state).failOnEmptyStores;
export const addRTSAnalytics = state => getRealTimeStock(state).addRTSAnalytics || false;

export const autofillEmail = state => getChangeEmail(state).autofillEmail;
export const redirectFromChangeEmail = state => getChangeEmail(state).redirect;
export const preventRedirectsFromChangeEmail = state => getChangeEmail(state).preventAllRedirects;
export const resetEmailFormFields = state => getChangeEmail(state).resetFormFields;

export const getChangePassword = state => getConfig(state).changePassword || {};
export const redirectFromChangePassword = state => getChangePassword(state).redirect;
export const resetPasswordFormFields = state => getChangePassword(state).resetFormFields;

export const messageDelay = state => getForms(state).messageDelay;
export const trimValue = state => getForms(state).trimValue || null;

export const preventPrefill = state => getForms(state).preventPrefill || {};
export const getPreventPrefillFieldsByForm = (state, formName) =>
    preventPrefill(state)[formName] || [];
export const setMobileNumber = state => getForms(state).setMobileNumber || false;
export const dobSortDescending = state => getForms(state).dobSortDescending || false;
export const removeMobileNumberFormat = state => getForms(state).removeMobileNumberFormat || false;
export const showProvinceAsAutoComplete = state =>
    getForms(state).showProvinceAsAutoComplete || false;
export const setFakeValidationAddressType = state =>
    getForms(state).setFakeValidationAddressType || false;
export const preFillCompanyOptionsFormFields = state =>
    getForms(state).preFillCompanyOptionsFormFields || false;

export const shouldValidatePinOrDOB = state => getForms(state).validatePinOrDOB || false;
export const showPopup = state => getRegistrationFormConfig(state).showPopup;
export const marketingProcessing = state => getRegistrationFormConfig(state).marketingProcessing;
export const registrationNestedFormField = state =>
    getRegistrationFormConfig(state).nestedFormField;
export const registrationLoyaltyPrefix = state =>
    getRegistrationFormConfig(state).loyaltyPrefix || '';
export const registrationShouldPopulateNest = state =>
    getRegistrationFormConfig(state).shouldPopulateNest;
export const registrationWithPinCode = state => getRegistrationFormConfig(state).withPinCode;
export const getShouldPreventPrefillFalsyValues = state =>
    getRegistrationFormConfig(state).preventPrefillFalsyValues;
export const getRegistrationClearPincode = state =>
    getRegistrationFormConfig(state).clearPincode || false;
export const getRegistrationTempValidation = state =>
    getRegistrationFormConfig(state).setTempValidationForLoyalty || false;
export const getHideDateOfBirthForPhysical = state =>
    getRegistrationFormConfig(state).hideDateOfBirthForPhysical || false;
export const useAgeVerification = state => getAgeVerification(state).enabled;
export const shouldCheckEmailAlreadyExist = state =>
    getRegistrationFormConfig(state).checkEmailAlreadyExist;
export const shouldResetSecondStepDataFields = state =>
    getRegistrationFormConfig(state).resetSecondStepDataFields;

export const preventAddToCartOnExceed = state => getCartConfig(state).preventAddToCartOnExceed;
export const mergeOldCart = state => getCartConfig(state).mergeOldCart;
export const applyDefaultAddressesOnLogin = state =>
    getCartConfig(state).applyDefaultAddressesOnLogin;

export const getCheckout = state => getConfig(state).checkout || {};

export const autofillLoyaltyCardForm = state => getDigitalCardFormConfig(state).autofillForm;

export const resetDOBErrorLoyaltyCardForm = state =>
    getDigitalCardFormConfig(state).resetErrorForValidDOB || false;

export const getOrderConformationRegistration = state =>
    getConfig(state).orderConformationRegistration || {};

export const preventRedirectPersonalInformationForm = state =>
    getPersonalInformationFormConfig(state).preventRedirect;

export const titleGenderMappingDisabledPersonalInformationForm = state =>
    getPersonalInformationFormConfig(state).titleGenderMappingDisabled;

export const getImmediatelyAdjustCart = state => getCartConfig(state).immediatelyAdjustCart;
export const getStopAdjustCartOnClose = state => getCartConfig(state).stopAdjustCartOnClose;

export const getSkipAutoAdjustmentOnPages = state =>
    getCartConfig(state).skipAutoAdjustmentOnPages || [];

export const getPickupExpressEnterPhonePage = state =>
    getCartConfig(state).pickupExpressEnterPhonePage || '';

export const shouldCheckLimitationBrand = state => getCartConfig(state).checkLimitationBrand;
export const getAcceptedLimitativeRoutes = state => getCartConfig(state).limitativeRoutes || '';

export const addAddressesToGuestCart = state => getCartConfig(state).addAddressesToGuestCart;
export const getResetAdjustedCartData = state => getCartConfig(state).resetAdjustedCartData;
export const getCompareAddress = state => getConfig(state).compareAddress || {};

export const getInputMasksConfig = state => getConfig(state).inputMasks || {};
export const removeDynaFormMessagesOnSubmit = state =>
    getDynaFormConfig(state).removeMessagesOnSubmit;
export const cleanPhoneNumber = state => getDynaFormConfig(state).cleanPhoneNumber || false;
export const checkFailedFormValidation = state =>
    getDynaFormConfig(state).checkFailedFormValidation || false;
export const getSwitchToFirstNotValidStep = state =>
    getDynaFormConfig(state).switchToFirstNotValidStep || false;
export const getScrollToFormCenterBySuccess = state =>
    getDynaFormConfig(state).scrollToFormCenterBySuccess || [];
export const getShouldScrollToFormCenterBySuccess = (state, formName) =>
    getScrollToFormCenterBySuccess(state).includes(formName) || false;

export const getFreeSamplesFlag = state => getDeliveryModes(state).freeSamplesFlag || false;
export const getGwpConfirmationDialog = state =>
    getDeliveryModes(state).gwpConfirmationDialog || false;
export const usePostPointAddressAfterLogin = state =>
    getDeliveryModes(state).usePostPointAddressAfterLogin || false;
export const getAddQueryParamCountry = state =>
    getDeliveryModes(state).addQueryParamCountry || false;

export const getGiftCardFormConfig = state => getConfig(state).giftcard || {};
export const getGiftWrapConfig = state => getConfig(state).giftWrap || {};

export const getAddressFormConfig = state => getConfig(state).myAddressForm || {};
export const getHiddenAddressFieldNames = state => getAddressFormConfig(state).fieldNames || [];
export const getSubmitAddressType = state => getAddressFormConfig(state).submitAddressType || '';
export const getCloseDialogWhenModalOpens = state =>
    getAddressFormConfig(state).closeDialogWhenModalOpens;
export const getOpenAddressBookAfterSubmit = state =>
    getAddressFormConfig(state).openAddressBookAfterSubmit;
export const getResetSelectedAddressAfterRemove = state =>
    getAddressFormConfig(state).resetSelectedAddressAfterRemove;
export const getAddDeferedValidated = state => getAddressFormConfig(state).addDeferedValidated;
export const getShowCorporateOptionFields = state =>
    getAddressFormConfig(state).showCorporateOptionFields;
export const getPsp = state => getConfig(state).psp || {};
export const getPspStylesConfig = state => getPsp(state).stylesConfig || null;
export const getProductConfig = state => getConfig(state).product || {};
export const shouldLoadReviewOnVariants = state =>
    getProductConfig(state).shouldLoadReviewOnVariants || false;
export const shouldSendVariantEvent = state => getProductConfig(state).sendVariantEvent || false;
export const collectProductsDataInStepOneOnly = state =>
    getProductConfig(state).collectProductsDataInStepOneOnly || false;
export const shouldSendVariantEventOnOpenedPopup = state =>
    getProductConfig(state).sendVariantEventOnOpenedPopup || false;
export const getDiscountPromoCondition = state =>
    getProductConfig(state).discountPromoCondition || [];
export const getMaxPromoDisplayed = state => getProductConfig(state).maxPromoDisplayed || 0;
export const collectStockInfo = state => getProductConfig(state).collectStockInfo || false;
export const saveLastViewedProductsCookie = state =>
    getProductConfig(state).saveLastViewedProductsCookie || false;
export const shouldCollectAdditionalGAInfo = state =>
    getProductConfig(state).collectAdditionalGAInfo || false;
export const showThumbnailSliderInImage = state =>
    getProductConfig(state).showThumbnailSliderInImage || false;

export const getEgiftcardPDPConfig = state => getConfig(state).egiftcardPDP || {};
export const getEgiftcardPDPModeConfig = (state, isMultiMode) =>
    getEgiftcardPDPConfig(state)[isMultiMode ? 'multi' : 'single'] || {};

export const saveGuestInputFromEgiftcardPDP = (state, isMultiMode) =>
    getEgiftcardPDPModeConfig(state, isMultiMode).saveGuestInput;
export const prefillFromStorageOnEgiftcardPDP = (state, isMultiMode) =>
    getEgiftcardPDPModeConfig(state, isMultiMode).prefillFromStorage;
export const getPrivacySelection = state => getConfig(state).privacySelection || {};
export const getCreditCardTokenizationConfig = state =>
    getConfig(state).creditCardTokenization || {};
export const getDynamicGiftCardsStatus = state => getPayment(state).dynamicGiftCards || false;
export const getHeaderConfig = state => getConfig(state).header || {};
export const isHeaderStickyOnScrollDown = state => getHeaderConfig(state).stickyOnScrollDown || {};
export const getAdjusCartOnCartPage = state => getCartConfig(state).adjustCartOnCartPage || false;
export const getOrderConfirmationProductDifferentiater = state =>
    getConfig(state).orderConformationProductSummary || {};
export const getProductDifferentiationRequiredStatus = state =>
    getOrderConfirmationProductDifferentiater(state).isProductDifferentiationRequired || false;
export const getSkipValidationRules = state => getConfig(state).skipValidationRules || {};
export const getSearchConfig = state => getConfig(state).search || {};
export const shouldShowNoResultsMessage = state =>
    getSearchConfig(state).showNoResulstMessage || false;
export const getCustomHeaderScrollHeight = state =>
    getConfig(state).customHeaderScrollHeight || false;

export const getEventTracking = state => getConfig(state).eventTracking || false;
export const getPageLoadInformation = state => getEventTracking(state).hasPageInfo || false;
export const setAnalyticsCookie = state => getEventTracking(state).setAnalyticsCookie || false;
export const doSetUserId = state => getEventTracking(state).setUserId || false;
export const waitForSetProfile = state => getEventTracking(state).waitForSetProfile || false;
export const setExtendedReviewData = state =>
    getEventTracking(state).setExtendedReviewData || false;
export const getResetActiveAlphabetFilter = state =>
    getConfig(state).resetActiveAlphabetFilter || {};
export const getResetActiveAlphabetFilterStatus = state =>
    getResetActiveAlphabetFilter(state).resetActiveAlphabetFilter || false;

export const getDeliveryPost = state => getConfig(state).deliveryPost || {};
export const useAnonymousDefaultAddress = state =>
    getDeliveryPost(state).useAnonymousDefaultAddress || false;
export const usePostPointAdditionalParams = state =>
    getDeliveryPost(state).usePostPointAdditionalParams || false;

export const getAdjustCartOnClickAndCollectExpress = state =>
    getCartConfig(state).adjustCartOnCandCEflow || false;
export const getIsOrderFullFillmentNotAllowedWithLC = state =>
    getCartConfig(state).isOrderFullFillmentNotAllowedWithLC || false;
export const getMinimumOrderThresholdForPWP = state =>
    getCartConfig(state).minimumOrderThresholdForPWP || false;
export const iframeRedirection = state => !!getPayment(state).iFrameRedirect;

export const distanceSellingContract = state =>
    !!getPayment(state).enableDistanceSellingContract || false;
export const preliminaryInformationForm = state =>
    !!getPayment(state).enablePreliminaryInformationForm || false;

export const hasAdjustConfirmationDialog = state =>
    getPayment(state).hasAdjustConfirmationDialog || false;

export const isTokenization = state => getPayment(state).isTokenization || false;

export const getPageLoad = state => getConfig(state).pageLoad || {};
export const shouldScrollAfterLoad = state => getPageLoad(state).scrollAfterLoad || false;

export const useLocationPageLoadInformation = state =>
    getEventTracking(state).showLocationInfo || false;

export const showUserParams = state => getEventTracking(state).showUserParams || false;
export const useUserIdPageLoadInformation = state =>
    getEventTracking(state).showUserIdInfo || false;
export const useCollectGAInformation = state => getEventTracking(state).collectGAInfo || false;
export const getGiftCardAmountDecimalSeparator = state =>
    getGiftCardFormConfig(state).giftCardAmountDecimalSeparator || '.';
export const getShouldUpdatePWPPoints = state =>
    getGiftCardFormConfig(state).shouldUpdatePWPPoints || false;

export const getDateOfBirthConfig = state => getConfig(state).changeDateOfBirth || {};
export const getCountrySpecificDateOfBirthConfig = (state, country) =>
    getDateOfBirthConfig(state)[country] || {};
export const shouldValidateByAge = (state, country) => {
    return getCountrySpecificDateOfBirthConfig(state, country).validateByAge || false;
};

export const getFilterConstraintsRules = state => getConfig(state).filterConstraintsRules || {};
export const getFilterConstraintsRulesByForm = (state, formStoreName) =>
    getFilterConstraintsRules(state)[formStoreName] || {};
export const getFilterConstraintsRulesByCountry = (state, formStoreName, country) =>
    getFilterConstraintsRulesByForm(state, formStoreName)[country] || {};
export const getFilterConstraintsRule = (state, formStoreName, country, fieldName) =>
    getFilterConstraintsRulesByCountry(state, formStoreName, country)[fieldName] || null;
export const getSkipGlobalInitialize = state => getCartConfig(state).skipGlobalInitialize || false;
export const getDeliveryModeForCnCE = state =>
    getCartConfig(state).clickAndCollectExpressDeliveryCode || '';
export const checkForEmptyStore = state => getCartConfig(state).checkForEmptyStore || false;
export const urlToNavigateIfStoreNotSelected = state =>
    getCartConfig(state).urlToNavigateIfStoreNotSelected || '';

export const setDataProtectionAccetpted = state =>
    getDigitalCardFormConfig(state).setDataProtectionAccetpted || false;

export const getPopupConfig = state => getConfig(state).popup || {};
export const addHistoryPushState = state => getPopupConfig(state).addHistoryPushState || false;
export const getPageConfig = state => getConfig(state).page || {};
export const shouldIgnoreResetOnLoad = state =>
    getPageConfig(state).shouldIgnoreResetOnLoad || false;

export const getFreeSamplesConfig = state => getConfig(state).freeSamples || {};
export const isFreeSamplesAccordionDefaultClosed = state =>
    getFreeSamplesConfig(state).defaultAccordionClosed;

export const getDefaultCheckoutCountryCheckConfig = state =>
    getConfig(state).defaultCheckoutCountryCheck || {};
export const isDefaultCheckoutCountryCheckEnabled = state =>
    getDefaultCheckoutCountryCheckConfig(state).isDefaultCountryCheckRequired;

export const getMarkDownPromotionConfig = state => getConfig(state).markDownPromotion || {};
export const useMarkDownPromotionValue = state =>
    getMarkDownPromotionConfig(state).useMarkdownPromotion || false;

export const isOosPromoBadge = state =>
    getMarkDownPromotionConfig(state).showOosPromoBadge || false;
export const getReviewsConfig = state => getConfig(state).reviews || {};
export const useFormDataOnReviewForm = state =>
    getReviewsConfig(state).useFormDataOnReviewForm || false;
export const shouldPrefillReviewForm = state =>
    getReviewsConfig(state).shouldPrefillReviewForm || false;
export const isMultipleFilters = state => getReviewsConfig(state).isMultipleFilters || false;
export const isWtrFlow = state => getReviewsConfig(state).isWtrFlow || false;
export const showLoyaltyMessages = state => getCartConfig(state).showLoyaltyMessages || false;
export const getVerifyPhonePopup = state => getUserConfig(state).verifyPhonePopup;
export const isRemoveAllGiftCard = state => getGiftCardFormConfig(state).removeAllGiftCard || false;
export const getOnBeforeUnloadScrollTop = state =>
    getConfig(state).plpFiltersConfig.plpFilters.onBeforeUnloadScrollTop || false;
export const brTracking = state => getEventTracking(state).brTracking || false;

export const shouldEnableShowMoreForExternalCatalog = state =>
    getProductConfig(state).shouldEnableShowMoreForExternalCatalog || false;

export const isDeliveryCountry = state => getProductConfig(state).isDeliveryCountry || false;

export const dlrTracking = state => getEventTracking(state).dlrTracking || false;
export const newLoyaltyRegistrationFlow = state =>
    getRegistrationFormConfig(state).newLoyaltyRegistrationFlow || false;
export const useNeighborhood = state => getAddressRelationsConfig(state).useNeighborhood || false;
export const neighborhoodFieldType = state =>
    getAddressRelationsConfig(state).neighborhoodFieldType || '';
export const getIsEerMinicart = state => getCartConfig(state).isEerMinicart || false;
export const removeStoreCtaDataOnDialogClose = state =>
    getProductConfig(state).removeStoreCtaDataOnDialogClose || false;
export const getAdjustDialogName = state => getDeliveryModes(state).adjustDialogName || '';
export const getUseLightWishlist = state => getWishlist(state).useLightWishlist || false;

export const shouldRedirectToPDPAfterLoginForNotifyMe = state =>
    getNotifyMeList(state).redirectToPDPAfterLogin || false;
